import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Privacidad } from "./components/Privacidad";
import { ClasesPage } from "./pages/clases/ClasesPage";
import { NotFound } from "./components/NotFound";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Clases de guitarra */}
        <Route path="/" element={
          <ClasesPage />
        } />

        {/* Página de privacidad */}
        <Route path="/privacidad" element={<Privacidad />} />

        {/* 404 - debe ser siempre la última ruta */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
